import { render, staticRenderFns } from "./questionnaire_sub_fields.vue?vue&type=template&id=64a6e05a&"
import script from "./questionnaire_sub_fields.vue?vue&type=script&lang=js&"
export * from "./questionnaire_sub_fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports